import { render, staticRenderFns } from "./ControlComponentLoadingSkeleton.vue?vue&type=template&id=55f28c82&"
import script from "./ControlComponentLoadingSkeleton.vue?vue&type=script&lang=ts&"
export * from "./ControlComponentLoadingSkeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports